import { CreateConversationFolderPayload } from "@rms-types/modules/conversation-folder/dto";
import { ConversationFolder } from "@rms-types/modules/conversation-folder/entities/conversation-folder";

import { getSnackbarMessages } from "@/helpers";
import { usePost, UsePostOptions } from "@/hooks";
import { conversationFolderEndpoint } from "@/constants";

export function useCreateConversationFolder(
  options: UsePostOptions<ConversationFolder, CreateConversationFolderPayload> = {}
) {
  const endpoint = conversationFolderEndpoint.conversationFolder;
  const { triggerPostErrorMessage, triggerPostSuccessMessage } = getSnackbarMessages("Folder");

  const {
    mutate: createConversationFolder,
    error: createConversationFolderError,
    isPending: isCreateConversationPending,
    ...rest
  } = usePost<ConversationFolder, CreateConversationFolderPayload>({
    endpoint,
    options: {
      ...options,
      onSuccess: (data, variables, context) => {
        options?.onSuccess && options.onSuccess(data, variables, context);
        triggerPostSuccessMessage();
      },
      onError: (error, variables, context) => {
        options?.onError && options.onError(error, variables, context);
        triggerPostErrorMessage(error);
      },
    },
  });

  return {
    createConversationFolder,
    createConversationFolderError,
    isCreateConversationPending,
    ...rest,
  };
}
